// 테이블 스타일 관련 공통 유틸리티
export const getTableStyles = (theme) => ({
    // 테이블 행 스타일
    tableRowStyle: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'transparent'
        },
        '&:nth-of-type(even)': {
            backgroundColor: 'transparent'
        },
        '&:hover': {
            backgroundColor: theme.palette.figma.white[10]
        }
    },
});